/**
 * Initial state
 */
export const state = {
  user: null,
  token: window.localStorage.getItem('auth_token')
}

/**
 * Mutations
 */
export const mutations = {

  SET_USER: (state, user ) => {
    state.user = user
    console.log(state.user)
  },

   SET_ROLE: (state, role) => {
    state.role = role;
    console.log(state.role);
  },

  LOGOUT: (state) => {
    state.user = null
    state.token = null
    window.localStorage.removeItem('auth_token')
  },

  FETCH_USER_FAILURE: (state) => {
    state.user = null
    state.token = null
    window.localStorage.removeItem('auth_token')
  },

  SET_TOKEN: (state,  token ) => {
    state.token = token
    window.localStorage.setItem('auth_token', token)
  }
}

/**
 * Actions
 */
export const actions = 
{
  saveToken({ commit }, payload) 
  {
    commit('SET_TOKEN', payload)
  },

  async fetchUser({ commit, dispatch }) 
  {
    try {      
      const res = await axios.post(`/api/auth/me`,{token:state.token})

        const role = res.data.roles;
        console.log("Auth role",role)

        commit('SET_USER', res)
        commit('SET_ROLE', role);

      commit('SET_USER', res)
    } catch (e) {
      commit('FETCH_USER_FAILURE')
    }
  },

  setUser({ commit }, payload) {
    commit('SET_USER', payload)
  },

  async logout({ commit }, payload) {
    await axios.post(api.path('auth.logout'))
    commit('LOGOUT', payload)
  },

  destroy({ commit }) {
    commit('LOGOUT', payload)
  }
}

/**
 * Getters
 */
export const getters = {
  user: state => state.user,
  check: state => state.user !== null,
  token: state => state.token,
  role: state =>  state.role 
}